import { render, staticRenderFns } from "./siprelad-operations.vue?vue&type=template&id=5e8b7f59&scoped=true&"
import script from "./siprelad-operations.vue?vue&type=script&lang=js&"
export * from "./siprelad-operations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b7f59",
  null
  
)

export default component.exports